// Ajusta o popup de preferências de cookis 

  document.addEventListener('DOMContentLoaded', function() {
    var observer;

    function updateCookieBanner() {
      var btnAccept = document.getElementById('shopify-pc__banner__btn-accept');
      var btnDecline = document.getElementById('shopify-pc__banner__btn-decline');
      var btnManage = document.querySelector('[id^="shopify-pc__banner__btn-manage"]');
      if (!btnAccept || !btnDecline) return;

      btnAccept.classList.add('btn', 'btn-primary');
      btnAccept.style.borderRadius = '40px';
      btnAccept.style.outline = 'none';
      btnAccept.style.boxShadow = 'none';
      btnDecline.classList.add('btn', 'btn-outline');
      btnDecline.style.borderRadius = '40px';
      btnDecline.style.border = '1px solid rgb(28, 28, 28)';
      btnDecline.style.outline = 'none';
      btnDecline.style.boxShadow = 'none';

      if (
        btnManage &&
        btnAccept.parentElement === btnDecline.parentElement &&
        btnAccept.parentElement === btnManage.parentElement
      ) {
        var actions = btnAccept.parentElement;
        actions.classList.add('kapazi-cookie-banner-actions');
        actions.append(btnManage, btnDecline, btnAccept);
        observer.disconnect();
      }
    }

    observer = new MutationObserver(updateCookieBanner);
    observer.observe(document.body, { childList: true, subtree: true });
    updateCookieBanner();
  });

  // Fim

// Bloqueia links vazios e abre links externos em nova aba

function isEmptyHashLink(link) {
  var rawHref = (link.getAttribute('href') || '').trim();
  if (rawHref === '#') return true;

  try {
    var parsedUrl = new URL(rawHref, window.location.origin);
    return parsedUrl.origin === window.location.origin && rawHref.endsWith('#') && parsedUrl.hash === '';
  } catch (error) {
    return false;
  }
}

document.addEventListener('click', function(e) {
  var link = e.target.closest('a');
  if (!link) return;

  if (isEmptyHashLink(link)) {
    e.preventDefault();
    return;
  }

  if (link.hostname !== window.location.hostname && link.hostname !== '') {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  }
}, true);

// Monta a mensagem do WhatsApp nos links configurados pelo tema.

function prepareWhatsappLink(link) {
  var messageTemplate = link.dataset.whatsappMessage || '';
  if (!messageTemplate) return;

  var baseHref = link.dataset.whatsappBaseHref || link.getAttribute('href');
  if (!baseHref || baseHref === '#') return;

  link.dataset.whatsappBaseHref = baseHref;

  try {
    var whatsappUrl = new URL(baseHref, window.location.origin);
    var message = messageTemplate.replace('{url}', window.location.href);
    whatsappUrl.searchParams.set('text', message);
    link.setAttribute('href', whatsappUrl.toString());
  } catch (error) {
    return;
  }
}

document.addEventListener('click', function(e) {
  var link = e.target.closest('[data-whatsapp-link]');
  if (!link) return;

  prepareWhatsappLink(link);
}, true);

// Atualiza o iframe do simulador quando a pagina recebe ?src=

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.indexOf('/pages/simulador') === -1) return;

  var params = new URLSearchParams(window.location.search);
  var simulatorSrc = params.get('src');
  if (!simulatorSrc) return;

  try {
    if (simulatorSrc.indexOf('://') === -1) {
      simulatorSrc = decodeURIComponent(simulatorSrc);
    }

    var simulatorUrl = new URL(simulatorSrc);
    if (simulatorUrl.protocol !== 'https:') return;

    var iframe = document.querySelector('iframe[src*="kapazi.floori.io"], iframe');
    if (iframe) {
      iframe.setAttribute('src', simulatorUrl.toString());
    }
  } catch (error) {
    return;
  }
});

// Ajusta posicoes dinamicas dos dots do lookbook por produto

document.addEventListener('DOMContentLoaded', function() {
  var desktopQuery = window.matchMedia('(min-width: 768px)');

  function normalizePosition(value) {
    if (value === null || value === undefined || value === '') return null;
    var number = parseFloat(String(value).replace('%', '').replace(',', '.'));
    if (Number.isNaN(number)) return null;
    return Math.min(100, Math.max(0, number));
  }

  function getInset(x, y) {
    return {
      top: y > 70 ? 'auto' : 'calc(100% + 1rem)',
      right: x > 70 ? '-100%' : 'auto',
      bottom: y > 70 ? 'calc(100% + 1rem)' : 'auto',
      left: x > 70 ? 'auto' : '-100%'
    };
  }

  function applyHotspotPositions(wrapper) {
    var raw = wrapper.dataset.hotspotDynamicPositions;
    if (!raw) return;

    var positions;
    try {
      positions = JSON.parse(raw);
    } catch (error) {
      return;
    }

    if (positions && Array.isArray(positions.hotspots)) {
      positions = positions.hotspots;
    }

    if (!Array.isArray(positions)) return;

    wrapper.querySelectorAll('[data-lookbook-hotspot]').forEach(function(dot, index) {
      var position = positions[index];

      if (!position || position.enabled === false) {
        dot.hidden = true;
        return;
      }

      dot.hidden = false;

      var x = normalizePosition(position.x);
      var y = normalizePosition(position.y);
      var mobileX = normalizePosition(position.mobile_x);
      var mobileY = normalizePosition(position.mobile_y);

      if (x === null || y === null) {
        dot.hidden = true;
        return;
      }

      if (mobileX === null) mobileX = x;
      if (mobileY === null) mobileY = y;

      dot.style.setProperty('--left', x + '%');
      dot.style.setProperty('--top', y + '%');
      dot.style.setProperty('--left-mobile', mobileX + '%');
      dot.style.setProperty('--top-mobile', mobileY + '%');

      var activeX = desktopQuery.matches ? x : mobileX;
      var activeY = desktopQuery.matches ? y : mobileY;
      var inset = getInset(activeX, activeY);
      var popover = dot.querySelector('.hotspot-dot__product, .hotspot-dot__featured');

      if (popover) {
        popover.style.inset = inset.top + ' ' + inset.right + ' ' + inset.bottom + ' ' + inset.left;
      }
    });
  }

  function applyAllHotspotPositions() {
    document.querySelectorAll('[data-hotspot-dynamic-positions]').forEach(applyHotspotPositions);
  }

  applyAllHotspotPositions();
  desktopQuery.addEventListener('change', applyAllHotspotPositions);
  document.addEventListener('shopify:section:load', applyAllHotspotPositions);
});

// Move o botão de WhatsApp do Product Information para o canto inferior no desktop

(function() {
  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var instances = [];
  var ticking = false;

  function setFloatingVisibility(instance, visible) {
    instance.floating.classList.toggle('is-visible', visible);
    instance.floating.setAttribute('aria-hidden', visible ? 'false' : 'true');

    var link = instance.floating.querySelector('a');
    if (link) {
      link.tabIndex = visible ? 0 : -1;
    }
  }

  function isPastPageMiddle() {
    var scrollableHeight = Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight
    );

    if (scrollableHeight <= 0) return false;

    return window.scrollY >= scrollableHeight / 2;
  }

  function isScrollToTopVisible() {
    var scrollToTop = document.querySelector('.scroll-to-top');
    if (scrollToTop) {
      return scrollToTop.classList.contains('is-visible');
    }

    return window.scrollY > window.innerHeight;
  }

  function isSourceVisible(instance) {
    var rect = instance.source.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function updateExpandedWidth(instance) {
    if (!instance.sourceLink) return;

    var width = instance.sourceLink.getBoundingClientRect().width;
    if (width > 0) {
      instance.floating.style.setProperty('--product-whatsapp-floating-expanded-width', Math.ceil(width) + 'px');
    }
  }

  function isFooterBrandLogoVisible() {
    var brandLogo = document.querySelector('[data-footer-brand-logo]');
    if (!brandLogo) return false;

    var rect = brandLogo.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function updateFooterPosition(instance, shouldMoveAbove) {
    if (typeof shouldMoveAbove !== 'boolean') {
      shouldMoveAbove = isFooterBrandLogoVisible();
    }
    var isAbove = instance.floating.classList.contains('is-near-footer');

    if (shouldMoveAbove === isAbove) return;

    if (instance.footerPositionTimer) {
      window.clearTimeout(instance.footerPositionTimer);
    }

    instance.floating.classList.remove('is-moving-to-footer', 'is-moving-from-footer');
    instance.floating.classList.add(shouldMoveAbove ? 'is-moving-to-footer' : 'is-moving-from-footer');
    instance.floating.classList.toggle('is-near-footer', shouldMoveAbove);
    instance.footerPositionTimer = window.setTimeout(function() {
      instance.floating.classList.remove('is-moving-to-footer', 'is-moving-from-footer');
      instance.footerPositionTimer = null;
    }, 360);
  }

  function syncInstance(instance) {
    var sourceVisible = isSourceVisible(instance);
    var shouldShow = !sourceVisible && (instance.trigger === 'source-hidden' || isScrollToTopVisible());
    var compact = instance.forceCompact || !desktopQuery.matches || isPastPageMiddle();
    updateExpandedWidth(instance);

    if (!shouldShow) {
      setFloatingVisibility(instance, false);
      if (instance.footerPositionTimer) window.clearTimeout(instance.footerPositionTimer);
      instance.floating.classList.remove('is-compact', 'is-near-footer', 'is-moving-to-footer', 'is-moving-from-footer');
      return;
    }

    instance.floating.classList.toggle('is-compact', compact);
    updateFooterPosition(instance);
    setFloatingVisibility(instance, true);
  }

  function syncAll() {
    ticking = false;
    instances.forEach(syncInstance);
  }

  function requestSync() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(syncAll);
  }

  function setupFloatingButton(floating) {
    if (floating.dataset.productWhatsappStickyReady === 'true') return;

    var id = floating.dataset.productWhatsappStickyFloating;
    var source = document.querySelector('[data-product-whatsapp-sticky-source="' + id + '"]');
    if (!source) return;

    var sourceLink = source.querySelector('.whatsapp-button a');
    if (!sourceLink) return;

    if (floating.parentElement !== document.body) {
      document.body.appendChild(floating);
    }

    var clonedLink = sourceLink.cloneNode(true);
    clonedLink.removeAttribute('id');
    clonedLink.tabIndex = -1;
    clonedLink.querySelectorAll('span').forEach(function(span) {
      if (span.querySelector('svg')) {
        span.classList.add('product-whatsapp-sticky-floating__icon');
      } else {
        span.classList.add('product-whatsapp-sticky-floating__label');
      }
    });
    floating.innerHTML = '';
    floating.appendChild(clonedLink);
    floating.dataset.productWhatsappStickyReady = 'true';

    var instance = {
      source: source,
      sourceLink: sourceLink,
      floating: floating,
      trigger: floating.dataset.productWhatsappStickyTrigger || 'scroll-to-top',
      forceCompact: floating.dataset.productWhatsappStickyCompact === 'always',
      hasBeenVisible: false
    };

    instances.push(instance);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(requestSync, { threshold: [0, 0.01, 1] });
      observer.observe(source);
      instance.observer = observer;
    }
  }

  function initProductWhatsappSticky(root) {
    root = root || document;
    root.querySelectorAll('[data-product-whatsapp-sticky-floating]').forEach(setupFloatingButton);
    requestSync();
  }

  document.addEventListener('DOMContentLoaded', function() {
    initProductWhatsappSticky(document);
    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);
    desktopQuery.addEventListener('change', requestSync);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initProductWhatsappSticky(event.target);
  });
})();

// Exibe um botão flutuante global de WhatsApp independente da lógica da PDP.

(function() {
  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var instances = [];
  var ticking = false;
  var footerCompactDelay = 540;

  function getScrollProgress() {
    var scrollableHeight = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    if (scrollableHeight <= 0) return 0;

    return Math.min(100, (window.scrollY / scrollableHeight) * 100);
  }

  function isScrollToTopVisible() {
    var scrollToTop = document.querySelector('.scroll-to-top');
    return scrollToTop ? scrollToTop.classList.contains('is-visible') : window.scrollY > window.innerHeight;
  }

  function setVisibility(instance, visible) {
    instance.element.classList.toggle('is-visible', visible);
    instance.element.setAttribute('aria-hidden', visible ? 'false' : 'true');
    instance.link.tabIndex = visible ? 0 : -1;
  }

  function updateExpandedWidth(instance) {
    var width = instance.sourceLink.getBoundingClientRect().width;
    if (width > 0) {
      instance.element.style.setProperty('--global-whatsapp-floating-expanded-width', Math.ceil(width) + 'px');
    }
  }

  function isFooterBrandLogoVisible() {
    var brandLogo = document.querySelector('[data-footer-brand-logo]');
    if (!brandLogo) return false;

    var rect = brandLogo.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function updateFooterPosition(instance, shouldMoveAbove, waitForCompact) {
    if (typeof shouldMoveAbove !== 'boolean') {
      shouldMoveAbove = isFooterBrandLogoVisible();
    }
    var isAbove = instance.element.classList.contains('is-near-footer');

    if (!shouldMoveAbove && instance.footerCompactTimer) {
      window.clearTimeout(instance.footerCompactTimer);
      instance.footerCompactTimer = null;
    }

    if (shouldMoveAbove && !isAbove && instance.footerCompactTimer) return;

    if (shouldMoveAbove && !isAbove && waitForCompact) {
      instance.footerCompactTimer = window.setTimeout(function() {
        instance.footerCompactTimer = null;
        updateFooterPosition(instance, isFooterBrandLogoVisible(), false);
      }, footerCompactDelay);
      return;
    }

    if (shouldMoveAbove === isAbove) return;

    if (instance.footerPositionTimer) {
      window.clearTimeout(instance.footerPositionTimer);
    }

    instance.element.classList.remove('is-moving-to-footer', 'is-moving-from-footer');
    instance.element.classList.add(shouldMoveAbove ? 'is-moving-to-footer' : 'is-moving-from-footer');
    instance.element.classList.toggle('is-near-footer', shouldMoveAbove);
    instance.footerPositionTimer = window.setTimeout(function() {
      instance.element.classList.remove('is-moving-to-footer', 'is-moving-from-footer');
      instance.footerPositionTimer = null;
    }, 360);
  }

  function syncInstance(instance) {
    var progress = getScrollProgress();
    var meetsShowThreshold = progress >= instance.showAt;
    var hasHideThreshold = instance.hideAt > instance.showAt && instance.hideAt < 100;
    var isBeforeHideThreshold = !hasHideThreshold || progress < instance.hideAt;
    var matchesScrollToTop = !instance.showWithScrollToTop || isScrollToTopVisible();
    var shouldShow = meetsShowThreshold && isBeforeHideThreshold && matchesScrollToTop;
    var expandsAgain = instance.expandAgainAt > instance.compactAt && instance.expandAgainAt < 100 && progress >= instance.expandAgainAt;
    var compact = instance.canCompact && (!desktopQuery.matches || (progress >= instance.compactAt && !expandsAgain));
    var isNearFooter = isFooterBrandLogoVisible();

    if (!shouldShow) {
      setVisibility(instance, false);
      if (instance.footerPositionTimer) window.clearTimeout(instance.footerPositionTimer);
      if (instance.footerCompactTimer) window.clearTimeout(instance.footerCompactTimer);
      instance.element.classList.remove('is-compact', 'is-near-footer', 'is-moving-to-footer', 'is-moving-from-footer');
      return;
    }

    updateExpandedWidth(instance);
    var wasCompact = instance.element.classList.contains('is-compact');
    var shouldCompact = compact || isNearFooter;
    instance.element.classList.toggle('is-compact', shouldCompact);
    updateFooterPosition(instance, isNearFooter, shouldCompact && !wasCompact);
    setVisibility(instance, true);
  }

  function syncAll() {
    ticking = false;
    instances.forEach(syncInstance);
  }

  function requestSync() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(syncAll);
  }

  function setupButton(floating) {
    if (floating.dataset.globalWhatsappFloatingReady === 'true') return;

    var id = floating.dataset.globalWhatsappFloating;
    var source = document.querySelector('[data-global-whatsapp-floating-source="' + id + '"]');
    if (!source) return;

    var sourceLink = source.querySelector('.whatsapp-button a');
    if (!sourceLink) return;

    if (floating.parentElement !== document.body) {
      document.body.appendChild(floating);
    }

    var link = sourceLink.cloneNode(true);
    link.removeAttribute('id');
    link.tabIndex = -1;

    link.querySelectorAll('span').forEach(function(span) {
      if (span.querySelector('svg')) {
        span.classList.add('global-whatsapp-floating__icon');
      } else {
        span.classList.add('global-whatsapp-floating__label');
      }
    });

    floating.innerHTML = '';
    floating.appendChild(link);
    floating.dataset.globalWhatsappFloatingReady = 'true';

    instances.push({
      element: floating,
      link: link,
      sourceLink: sourceLink,
      showAt: Number(floating.dataset.showAtScroll || 0),
      hideAt: Number(floating.dataset.hideAtScroll || 100),
      compactAt: Number(floating.dataset.compactAtScroll || 50),
      expandAgainAt: Number(floating.dataset.expandAgainAtScroll || 100),
      showWithScrollToTop: floating.dataset.showWithScrollToTop === 'true',
      canCompact: Boolean(link.querySelector('svg'))
    });
  }

  function initGlobalWhatsappFloating(root) {
    root = root || document;
    root.querySelectorAll('[data-global-whatsapp-floating]').forEach(setupButton);
    requestSync();
  }

  document.addEventListener('DOMContentLoaded', function() {
    initGlobalWhatsappFloating(document);
    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);
    desktopQuery.addEventListener('change', requestSync);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initGlobalWhatsappFloating(event.target);
  });
})();
